/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon, Image, Popup, PopupContent } from 'semantic-ui-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom-v5-compat'
import PlatformModule from '../../../../../services/Platform/PlatformModule'
import useUser from '../../../../Shared/UserProvider/useUser'
import { intlFormat } from '../../../../../helpers/money'

const SubstitutionDeliverooDisclaimer = ({initialPrice, substitutedPrice, position = 'top center', ...props}) => {
    const [t] = useTranslation()
    const {user} = useUser()

    const queryClient = useQueryClient()
    const {id} = useParams()
    const order = queryClient.getQueryData(['orders', +id])

    const shouldDisplayDisclaimer =
      order?.platform.module === PlatformModule.DELIVEROO &&
      substitutedPrice && initialPrice && substitutedPrice > initialPrice

    if (!shouldDisplayDisclaimer) {
        return null
    }

    return (
      <span className={props.className}>
          <Popup
            position={position}
            trigger={<Icon fitted name="info circle"/>}
          >
              <PopupContent>
                  <p css={css`
                      margin-bottom: .5rem;
                  `}>
                      <Image
                        css={css`
                            &.ui.image {
                                display: inline;
                                width: 20px;
                                margin-right: .5rem;
                                vertical-align: text-bottom;
                            }
                        `}
                        src={order.platform.logo}
                      />
                      {t('order.substitution.deliveroo_disclaimer.disclaimer')}
                  </p>
                  <div>
                      {t('order.substitution.deliveroo_disclaimer.substitutedPrice', {price: intlFormat(substitutedPrice, user.getCompanyCurrency(), user.getCompanyLocale())})}
                      <span css={css`
                          margin: 0 .5rem;
                          font-weight: bold;
                      `}>&gt;</span>
                      {t('order.substitution.deliveroo_disclaimer.initialPrice', {price: intlFormat(initialPrice, user.getCompanyCurrency(), user.getCompanyLocale())})}
                  </div>
              </PopupContent>
          </Popup>
      </span>
    )
}

export { SubstitutionDeliverooDisclaimer }
